import * as models from './models';

export enum V2_EVENT_TYPES {
  PRODUCT_VIEW = 'epv',
  CATEGORY_VIEW = 'ecv',
  PAGE_VIEW = 'pageView',
  LOG_ENTRY = 'log',
  // TODO: cart events
  // TODO: purchase event
  // TODO: search event
}

export interface V2EventBase {
  type: V2_EVENT_TYPES | string;
  // SDK may send timestamp field with event, but its ignored by API
  timestamp?: models.Timestamp;
}

export interface EventProductView extends V2EventBase, models.Product {
  type: V2_EVENT_TYPES.PRODUCT_VIEW;
}

export interface EventCategoryView extends V2EventBase, models.ProductCategory {
  type: V2_EVENT_TYPES.CATEGORY_VIEW;
}

export interface EventCustom extends V2EventBase {
  type: string;
  [property: string]: any;
}

export interface EventPageView extends V2EventBase, models.PageView {
  type: V2_EVENT_TYPES.PAGE_VIEW;
}

export interface EventLogEntry extends V2EventBase, models.LogEntry {
  type: V2_EVENT_TYPES.LOG_ENTRY;
}

export type V2Event =
  | EventCategoryView
  | EventProductView
  | EventPageView
  | EventLogEntry
  | EventCustom;
